import { Pipe, PipeTransform } from '@angular/core';
import { FeatureName, Tags } from '@tekman/onmat/models';

@Pipe({
  name: 'feature',
})
export class featurePipe implements PipeTransform {
  transform(tags: Tags[], feature: FeatureName): boolean {
    return tags?.find(item => item.name === feature)?.value ?? false;
  }
}
